import {BannerApoyoEconomico, BannerApoyoEducativo, BannerDiscapacitado, BannerDscs,} from "../images";

export const subDepartments = [
  {
    id: "sad-01",
    departmentId: "dae-02",
    title: "s.a.d",
    titleLarge: "Sección de Apoyo al Discapacitado",
    banner: BannerDiscapacitado,
    externalUrl: "https://sad.jbiene.com/",
  },

  {
    id: "saed-02",
    departmentId: "dae-02",
    title: "saes",
    titleLarge: "Sección de Apoyo Estudios Superiores",
    banner: BannerApoyoEducativo,
    externalUrl: "https://saed.jbiene.com/",
  },

  {
    id: "saeco-03",
    departmentId: "dae-02",
    title: "SSS",
    titleLarge: "Sección de Servicio Social",
    banner: BannerApoyoEconomico,
    externalUrl: "https://apoyosocial.jbiene.com/",
  },

  {
    id: "saeco-04",
    departmentId: "dae-02",
    title: "DSCS",
    titleLarge: "Departamento de Supervisión de Calidad del Servicio",
    banner: BannerDscs,
    externalUrl: "https://dscs.jbiene.com/",
  },
];
